export default __webpack_public_path__ + "images/8114fc160853892a8e0bce75a296b98c.svg";